import type { ComponentProps } from 'react';

import type { FieldPath, FieldValues } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { CompoundType } from '@polyai/common/types/helpers';

import NewRichTextInput from '../RichTextInput';
import type { SharedFormProps } from './types';

type Props<T> = CompoundType<
  SharedFormProps<T> &
    Omit<ComponentProps<typeof NewRichTextInput>, 'onChange' | 'value'> & {
      referencesField?: FieldPath<FieldValues>;
      resetReferences?: boolean;
    }
>;

export const NewFormRichTextInput = <T,>({
  controlKey,
  referencesField,
  resetReferences,
  ...rest
}: Props<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={controlKey as string}
      render={({ field, fieldState: { error } }) => (
        <NewRichTextInput
          {...field}
          errors={!!error ? [error.message || ''] : []}
          referencesField={referencesField}
          resetReferences={resetReferences}
          onChange={value => {
            field.onChange(value);
          }}
          {...rest}
        />
      )}
    />
  );
};
